export const productOptionSwatchStyles = {
  default: "default",
  dashed: "dashed",
};

export const productOptionSizes = {
  default: "default",
  small: "small",
};

export const unavailableStockStatuses = {
  waitlist: ["notifyMe", "notifyMeDate"],
  notInStock: [
    "outOfStock",
    "reserveNow",
    "reserveNowDate",
    "notifyMe",
    "notifyMeDate",
    "madeToOrder",
  ],
};
